// import tex from "../../../assets/custom/textures/randomTexture.png";
import tex from "./assets/textureRandom.png";

export const randomTexture = new THREE.TextureLoader().load(tex);
